import React, { useEffect, useState } from 'react'
import BossDialog from '../../components/BossDialog';
import { useTranslation } from '../../locale/useTranslation';
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { ENTITYNAME } from '../../framework/constant/constant';
import * as API from "../../framework/API/api";

const MamAssetShowAttachedMediaForm = (props) => {

    const lang = useTranslation();

    const [gridData, setGridData] = useState([]);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        //case 1 - Short FOrm
        let shortFormRes = await API.getData(ENTITYNAME.MediaEpisode, { query: [['MediaCategory.isLong', '=', false], ["Mam._id", "=", props.mamItem._id]] });
        //case 2 - Long Form
        let segmentRes = await API.getData(ENTITYNAME.MediaEpisodeSegment, { query: [["Mam._id", "=", props.mamItem._id]] });

        let longFormRes = await API.getData(ENTITYNAME.MediaEpisode, { query: [['MediaCategory.isLong', '=', true], ["SID", "in", segmentRes.data.map((s) => s.MediaEpisodeSID)]] });

        let shortFormData = (shortFormRes?.data || []).map(item => ({
            Title: item.Title,
            AssetId: item.AssetId,
            MediaCategory: item.MediaCategory
        }));

        let longFormData = (longFormRes?.data || []).map(item => ({
            Title: item.Title,
            AssetId: item.AssetId,
            MediaCategory: item.MediaCategory
        }));

        let finalData = [...shortFormData, ...longFormData];
        setGridData(finalData);
    }

    const mamHyperLinkCell = (props) => {
        const { dataItem, field } = props;
        const value = dataItem[field];

        const isMovieOrProgram = ["Movie", "Program"].includes(dataItem?.MediaCategory?.Description);
        const dynamicId = isMovieOrProgram ? dataItem?.AssetId : dataItem?.MediaCategory?.SID;

        return (
            <td>
                <div style={{ color: 'blue', cursor: 'pointer' }} onClick={() => window.open(`/home/MediaEpisode/${dataItem?.MediaCategory?.Description}/${dynamicId}`, '_blank')}>
                    {value}
                </div>
            </td>
        );
    };

    return (
        <BossDialog
            title={lang.show_attached_media_dialog_header}
            onClose={props.onClose}
            width={"45vw"}
        >
            <Grid style={{ height: "45vh", marginTop: "5px" }} data={gridData} resizable={true}>
                <Column field="Title" title={lang.title_column} cell={mamHyperLinkCell} />
                <Column field="AssetId" title={lang.assetId_column} />
                <Column field="MediaCategory.Description" title={lang.media_category_column} />
            </Grid>
        </BossDialog >
    )
}

export default MamAssetShowAttachedMediaForm